import { CLIENTS_FILTER } from '@app/constants';

import { handleSecondClientObjectIndex } from '@pages/Clients/ClientsList/utils';

import {
  ClientsAge,
  ClientsBirthday,
  ClientsBirthdayLabel,
  ClientsClearButton,
  ClientsGender,
  ClientsGenderLabel,
  ClientsSales,
  ClientsTags,
  ClientsTagsLabel,
  RangeLabel,
} from '@pages/Clients/ClientsList/components/Filters';
import { ClientsBalance } from '@pages/Clients/ClientsList/components/Filters/ClientsBalance';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const filtersByClients: NClientsList.FiltersByGroup = ({
  filterGroupsId,
  filterGroupIndex,
}) => {
  const handledFilterGroupIndexForDisabling = filterGroupIndex || 0;
  const handledFilterGroupIndex = handleSecondClientObjectIndex(
    handledFilterGroupIndexForDisabling
  );

  return [
    {
      key: 'clientsGender',
      label: (
        <ClientsGenderLabel includedFiltersIndex={handledFilterGroupIndex} />
      ),
      children: [
        {
          key: 'clientsGenderChild',
          label: (
            <ClientsGender
              includedFiltersIndex={handleSecondClientObjectIndex(
                filterGroupIndex || 0
              )}
            />
          ),
        },
      ],
    },
    {
      key: 'clientsTags',
      label: (
        <ClientsTagsLabel includedFiltersIndex={handledFilterGroupIndex} />
      ),
      children: [
        {
          key: 'clientsTagsChild',
          label: (
            <ClientsTags
              includedFiltersIndex={handleSecondClientObjectIndex(
                filterGroupIndex || 0
              )}
              filterGroupsId={filterGroupsId || ''}
            />
          ),
        },
      ],
    },
    {
      key: 'clientsSales',
      label: (
        <RangeLabel
          className="clients-sales-label"
          label="Продано"
          filtersArea={CLIENTS_FILTER}
          includedFiltersIndex={handledFilterGroupIndex}
          minFilterKey="MinServicesCost"
          maxFilterKey="MaxServicesCost"
        />
      ),
      children: [
        {
          key: 'clientsSalesChild',
          label: (
            <ClientsSales
              labelClassName="clients-sales-label"
              includedFiltersIndex={handleSecondClientObjectIndex(
                filterGroupIndex || 0
              )}
            />
          ),
        },
      ],
    },
    {
      key: 'clientsBirthDay',
      label: (
        <ClientsBirthdayLabel includedFiltersIndex={handledFilterGroupIndex} />
      ),
      children: [
        {
          key: '',
          label: (
            <ClientsBirthday
              includedFiltersIndex={handleSecondClientObjectIndex(
                filterGroupIndex || 0
              )}
            />
          ),
        },
      ],
    },
    {
      key: 'clientsAge',
      label: (
        <RangeLabel
          className="clients-age-label"
          label="Возраст"
          filtersArea={CLIENTS_FILTER}
          includedFiltersIndex={handledFilterGroupIndex}
          minFilterKey="MinAge"
          maxFilterKey="MaxAge"
        />
      ),
      children: [
        {
          key: 'clientsAgeChild',
          label: (
            <ClientsAge
              labelClassName="clients-age-label"
              includedFiltersIndex={handleSecondClientObjectIndex(
                filterGroupIndex || 0
              )}
            />
          ),
        },
      ],
    },
    {
      key: 'clientsBalance',
      label: (
        <RangeLabel
          className="clients-balance-label"
          label="Баланс"
          filtersArea={CLIENTS_FILTER}
          includedFiltersIndex={handledFilterGroupIndex}
          minFilterKey="BalanceS"
          maxFilterKey="BalanceE"
        />
      ),
      children: [
        {
          key: 'clientsBalanceChild',
          label: (
            <ClientsBalance
              labelClassName="clients-balance-label"
              includedFiltersIndex={handleSecondClientObjectIndex(
                filterGroupIndex || 0
              )}
            />
          ),
        },
      ],
    },
    {
      key: 'visitsClearButton',
      label: (
        <ClientsClearButton includedFiltersIndex={handledFilterGroupIndex} />
      ),
    },
  ];
};
